import { useCallbackRef } from './useRef';
import { assignRef } from './assignRef';
export function useMergeRefs(refs, defaultValue) {
    return useCallbackRef(defaultValue, function (newValue) {
        return refs.forEach(function (ref) { return assignRef(ref, newValue); });
    });
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/use-callback-ref/dist/es2015/useMergeRef.js
// module id = 565
// module chunks = 0